<div class="card">
	<div class="card-header border-0 pt-6">
		<div class="card-title">
			<div class="d-flex align-items-center position-relative my-1">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" data-table-filter="search" class="form-control form-control-sm w-250px ps-12" placeholder="Search" />
			</div>
		</div>
		<div class="card-toolbar">
			<button type="button" class="btn btn-sm btn-primary me-3 text-nowrap" (click)="openAddModal()">
				<i class="ki-duotone ki-plus fs-2">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<span>Add Cr/Dr Notes</span>
			</button>
			<div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
				<div class="fw-bold me-5">
					<span class="me-2" data-table-select="selected_count"></span>Selected
				</div>
				<button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">Delete Selected</button>
			</div>
		</div>
	</div>
	<div class="card-body pt-0">
		<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_drcr_notes">
			<thead>
				<tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
					<th class="text-nowrap">
						<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
							<input class="form-check-input" type="checkbox" data-kt-check="true" data-kt-check-target="#kt_table_drcr_notes .invoice-number-check" value="1" />
						</div>
					</th>
					<th class="text-nowrap">Ref. #</th>
					<th class="text-nowrap w-150px">Customer Name</th>
					<th class="text-nowrap">Invoice #</th>
					<th class="text-nowrap">Date</th>
					<th class="text-nowrap">Debit</th>
					<th class="text-nowrap">Credit</th>
					<th class="text-nowrap">Brief</th>
					<th class="text-nowrap">Actions</th>
				</tr>
			</thead>
			<tbody class="text-gray-600 fw-semibold">
				<!-- Loading State -->
				<tr *ngIf="isLoading">
					<td colspan="20" class="text-center py-5">
						<div class="d-flex justify-content-center align-items-center">
							<span class="spinner-border spinner-border-sm me-2"></span>
							Loading Credit/Debit Notes...
						</div>
					</td>
				</tr>

				<!-- No Data State -->
				<tr *ngIf="!isLoading && (creditDebitNotes$ | async)?.length === 0">
					<td colspan="9" class="text-center py-5 text-muted">
						No credit/debit notes found
					</td>
				</tr>

				<!-- Data Rows -->
				<tr *ngFor="let note of creditDebitNotes$ | async; trackBy: trackByFn">
					<td class="text-nowrap">
						<div class="form-check form-check-sm form-check-custom form-check-solid">
							<input class="form-check-input invoice-number-check" type="checkbox" [value]="note._id" />
						</div>
					</td>
					<td class="text-nowrap">{{ note.reference_number || '-' }}</td>
					<td class="text-nowrap w-150px">
						{{ note.customer?.name || '-' }}<br>
						<small class="text-muted" *ngIf="note.customer?.company || note.customer?.country">
							[{{ note.customer?.company || '' }}{{ note.customer?.company && note.customer?.country ? ', ' : '' }}{{ note.customer?.country || '' }}]
						</small>
					</td>
					<td class="text-nowrap">{{ note.invoice_no || '-' }}</td>
					<td class="text-nowrap">{{ note.date | date:'yyyy-MM-dd' }}</td>
					<td class="text-nowrap">{{ note.type === '25' ? (note.amount | currency:'¥':'symbol':'1.0-0') : '¥ 0' }}</td>
					<td class="text-nowrap">{{ note.type === '10' ? (note.amount | currency:'¥':'symbol':'1.0-0') : '¥ 0' }}</td>
					<td class="text-nowrap">{{ note.brief || '-' }}</td>
					<td class="text-nowrap">
						<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
							<i class="ki-duotone ki-down fs-5 m-0"></i>
						</a>
						<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
							<div class="menu-item px-3">
								<a href="javascript:void(0)" class="menu-link px-3" (click)="openEditModal(note)">Edit</a>
							</div>
							<div class="menu-item px-3">
								<a href="javascript:void(0)" class="menu-link px-3" (click)="deleteCreditDebitNote(note)">Delete</a>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<app-add-update-credit-debit-notes (creditDebitNoteAdded)="onCreditDebitNoteAdded()" (creditDebitNoteUpdated)="onCreditDebitNoteUpdated()"></app-add-update-credit-debit-notes>
